import { CommandConfig } from '../../CommandConfig';

export default {
  command: 'create <name>',
  description: 'Create a new project',
  options: [],
} as CommandConfig;
